import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

// Components
import { Text, If, Unless, BotHeadSpin } from '../../../../Components'

// Utils
import { dispatchEvent } from '../../../../helpers/tagManager'
import { SignUpClientNotFound } from '../../../../constants/trackingEvents'

// Context
import { useSignUpProvider } from '../SignUpContext'

// Styles
import styles from './ClientNotFound.module.scss'

const ClientNotFound = () => {
  const {
    loading,
    formState: { email },
  } = useSignUpProvider()

  useEffect(() => {
    dispatchEvent(SignUpClientNotFound)
  }, [])

  return (
    <>
      <Unless condition={loading}>
        <div className={styles.emailStep}>
          <Text
            weight='light'
            size='xl'
            variant='neutralCool'
            variantCount='900'
            className={styles.headline}
          >
            <FormattedMessage
              id='NewBuyerSignUp.clientNotFound.cta'
              defaultMessage='You need an existing account'
            />
          </Text>
          <Text size='s' variant='neutralCool' variantCount='700'>
            <FormattedMessage
              id='NewBuyerSignUp.clientNotFound.label'
              defaultMessage='There was no account found for:'
            />
          </Text>
          <Text variant='warning' size='xxs' className={styles.emailAddress}>
            {email}
          </Text>
          <Text
            size='s'
            variant='neutralCool'
            variantCount='700'
            className={styles.helper}
          >
            <FormattedMessage
              id='NewBuyerSignUp.clientNotFound.helper'
              defaultMessage='To continue, you need an email address that currently receives Homebot emails.'
            />
          </Text>
        </div>
      </Unless>
      <If condition={loading}>
        <BotHeadSpin panelSpacing />
      </If>
    </>
  )
}

export default ClientNotFound
